import { Loader2, Mic, Square } from "lucide-react";

import { cn } from "@/lib/utils";

const rotulo = (ouvindo: boolean, transcrevendo: boolean) =>
  transcrevendo
    ? "Transcrevendo áudio…"
    : ouvindo
      ? "Parar gravação"
      : "Ditado por voz";

/**
 * O botão do microfone (ver useDitado). Desligado: microfone. Gravando: pulsa
 * em vermelho e vira "parar" — parar transcreve para o campo (enviar é com Enter). Transcrevendo: gira.
 */
export const BotaoMicrofone = ({
  ouvindo,
  transcrevendo = false,
  aoAlternar,
  desabilitado,
  className,
}: {
  ouvindo: boolean;
  transcrevendo?: boolean;
  aoAlternar: () => void;
  desabilitado?: boolean;
  className?: string;
}) => (
  <button
    type="button"
    onClick={aoAlternar}
    disabled={transcrevendo || (desabilitado && !ouvindo)}
    aria-pressed={ouvindo}
    aria-busy={transcrevendo}
    aria-label={rotulo(ouvindo, transcrevendo)}
    title={rotulo(ouvindo, transcrevendo)}
    className={cn(
      "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors disabled:opacity-40",
      ouvindo
        ? "animate-pulse border-red-500 bg-red-500 text-white"
        : "border-border bg-transparent text-muted-foreground hover:bg-accent hover:text-foreground",
      className,
    )}
  >
    {transcrevendo ? (
      <Loader2 className="h-4 w-4 animate-spin" />
    ) : ouvindo ? (
      <Square className="h-3.5 w-3.5 fill-current" />
    ) : (
      <Mic className="h-4 w-4" />
    )}
  </button>
);
